import $axios from "../../api/axios";

function getListApi({ callback }) {
  $axios
    .post("/api/faqList")
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getListApi
};



// WEBPACK FOOTER //
// ./src/api/faq/faq.js